// employee/reducers.ts
const initialState = {
    getExpensecategoryData: [],
    getExpensecategoryCount: null,
    createExpensecategoryData: null,
    updateExpensecategoryData: null,
    getExpensecategoryMetaMessage: null,
    getExpensecategorySuccess: false,
    getExpensecategoryFailure: false,
    createExpensecategorySuccess: false,
    createExpensecategoryFailure: false,
    updateExpensecategorySuccess: false,
    updateExpensecategoryFailure: false,
    deleteExpensecategorySuccess: false,
    deleteExpensecategoryFailure: false,
};

export default function ExpensecategoryReducer(state = initialState, action: any) {
    switch (action.type) {
        case 'GET_EXPENSECATEGORY_SUCCESS': {
            return {
                ...state,
                getExpensecategorySuccess: true,
                getExpensecategoryData: action.payload?.data?.data?.data,
                getExpensecategoryCount:action.payload?.data?.data?.meta?.total,
                getExpensecategoryFailure: false,
            };
        }
        case 'GET_EXPENSECATEGORY_FAILURE': {
            return {
                ...state,
                getExpensecategoryFailure: true,
                getExpensecategoryMetaMessage: action.payload?.data?.data?.meta?.message,
                getExpensecategorySuccess: false,
            };
        }
        case 'RESET_GET_EXPENSECATEGORY': {
            return {
                ...state,
                getExpensecategorySuccess: false,
                getExpensecategoryFailure: false,
                getExpensecategoryData: [],
                getExpensecategoryMetaMessage: null,
            };
        }

        case 'CREATE_EXPENSECATEGORY_SUCCESS': {
            return {
                ...state,
                createExpensecategorySuccess: true,
                createExpensecategoryData: action.payload?.data?.data?.data,
                getExpensecategoryMetaMessage: action.payload?.data?.data?.meta?.message,
                createExpensecategoryFailure: false,
            };
        }
        case 'CREATE_EXPENSECATEGORY_FAILURE': {
            return {
                ...state,
                createExpensecategoryFailure: true,
                getExpensecategoryMetaMessage: action.payload?.data?.data?.meta?.message,
                createExpensecategorySuccess: false,
            };
        }
        case 'RESET_CREATE_EXPENSECATEGORY': {
            return {
                ...state,
                createExpensecategorySuccess: false,
                createExpensecategoryFailure: false,
                createExpensecategoryData: null,
                getExpensecategoryMetaMessage: null,
            };
        }

        case 'UPDATE_EXPENSECATEGORY_SUCCESS': {
            return {
                ...state,
                updateExpensecategorySuccess: true,
                updateExpensecategoryData: action.payload?.data?.data?.data,
                getExpensecategoryMetaMessage: action.payload?.data?.data?.meta?.message,
                updateExpensecategoryFailure: false,
            };
        }
        case 'UPDATE_EXPENSECATEGORY_FAILURE': {
            return {
                ...state,
                updateExpensecategoryFailure: true,
                getExpensecategoryMetaMessage: action.payload?.data?.data?.meta?.message,
                updateExpensecategorySuccess: false,
            };
        }
        case 'RESET_UPDATE_EXPENSECATEGORY': {
            return {
                ...state,
                updateExpensecategorySuccess: false,
                updateExpensecategoryFailure: false,
                updateExpensecategoryData: null,
                getExpensecategoryMetaMessage: null,
            };
        }

        case 'DELETE_EXPENSECATEGORY_SUCCESS': {
            return {
                ...state,
                deleteExpensecategorySuccess: true,
                getExpensecategoryMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteExpensecategoryFailure: false,
            };
        }
        case 'DELETE_EXPENSECATEGORY_FAILURE': {
            return {
                ...state,
                deleteExpensecategoryFailure: true,
                getExpensecategoryMetaMessage: action.payload?.data?.data?.meta?.message,
                deleteExpensecategorySuccess: false,
            };
        }
        case 'RESET_DELETE_EXPENSECATEGORY': {
            return {
                ...state,
                deleteExpensecategorySuccess: false,
                deleteExpensecategoryFailure: false,
                getExpensecategoryMetaMessage: null,
            };
        }

        default: {
            return state;
        }
    }
}
